/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useHistory} from "react-router-dom";
import _ from "lodash";


import gitHubLogo from "../../images/gitHubLogo.svg";
import profileImg from "../../images/profile-img.jpeg";
import stackoverflowLogo from "../../images/stackoverflowLogo.svg";
import searchIcon from "../../images/search.png";
import attitudeIcon from "../../images/attitude.png";
import communityIcon from "../../images/community.png";
import passionIcon from "../../images/passion.png";
import commIcon from "../../images/comm.png";
import trustIcon from "../../images/trust.png";
import qaIcon from "../../images/qa.png";
// import shareIcon from "../../images/share1.png";
import newTabIcon from "../../images/newtab.png";
import LinkedInLogo from "../../images/linkedin.png";

import Nav from "../../components/RequestRating/Nav";
import Drawer from "../../components/RequestRating/Drawer";
import Footer from "../../components/RequestRating/Footer";
import { RecruiterOrEmployerSalesText, RecruiterOrEmployerSalesTitleText } from "../../components/RequestRating/NonLoggedView";
import NonLoggedView from "../../components/RequestRating/NonLoggedView";

import LoginGitHub from "../../components/RequestRating/LoginGithub";
import GithubRankingHeading from "../../components/RequestRating/GithubRankingHeading";
import LoginStackOverflow from "../../components/RequestRating/LoginStackoverflow";
import StackOverflowRankingHeading from "../../components/RequestRating/StackOverflowRankingHeading";
import RankingGHOrSO from "../../components/RequestRating/RankingGHOrSO";
import { NotEnoughData_Msg } from "../../components/RequestRating/RankingGHOrSO";
import PaymentsModal from "../../components/RequestRating/PaymentsModal";

import Share from "../../components/RequestRating/Share";
import ErrorCard from "../../components/ErrorCard";
import LoadingAnimation from "../../components/LoadingAnimation";
import axios from "axios";

import {
  TOTAL_GITHUB_USERS,
  TOTAL_STACKOVERFLOW_USERS,
} from "../../utils/totalNumberUsers";

import {
  APP_NAME,
  DISPLAY_STRING_GH,
  DISPLAY_STRING_SO,
  GITHUB_STRING,
  SO_STRING,
} from "../../utils/serviceName";
import LEVEL_DIALOG from "../../components/Level_dialog";
import OtherRankingRegister from "../../components/OtherRankingRegister";

import {generate_profile, getStackOverflowUsername, getStackOverflowUsername_userid, getGitHubUsername, crunchOtherRating, crunchOtherDetailedAnalysis,
  crunchOtherRatingStackOverflow,crunchOwnRating,crunchOwnRatingStackOverflow, checkValidUrl, checkValidStackOverflowUrl, checkValidGitHubUrl, 
  extractUserId, extractUsername, fixedEncodeURIComponent, checkRating} from './RequestRatingHelperFunctions'
// import { GithubLoginButton } from "react-social-login-buttons";
// 2021-04-012 relative-ratings-app RequestRating.js and relative-rankings-chrome-extension functions.js share this same code => move to shared component

// regex to check if the entered str is github url

const RequestRating = (props) => {
  const history = useHistory();
  const [showShare, setShowShare] = useState(false);
  const [enteredText, setEnteredText] = useState("");
  const [showError, setShowError] = useState({ show: false, msg: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState("");
  const [resultStackOverflow, setResultStackOverflow] = useState("");
  const [username, setUsername] = useState("");
  //Get/set Stack Overflow display name
  const [SOusername, setSOusername] = useState("");
  //Get/set StackOverflow userID
  const [userid, setUserId] = useState("");

  const [ownRatingGH, setOwnRatingGH] = useState(false);
  const [ownRatingSO, setOwnRatingSO] = useState(false);
  const [hash, setHash] = useState("");
  const [hideSO, setHideSO] = useState(false);
  const [hideGH, setHideGH] = useState(false);
  const [uuidCredit, setUuidCredit] = useState("");
  const [outstandingCredit, setOutstandingCredit] = useState(0);
  const [githubToken, setGitHubToken] = useState("");
  const [stackoverflowToken, setStackOverflowToken] = useState("");

  const [drawerVisible, toggleDrawer] = useState(false);

  const [numMilUsers, setNumMilUsers] = useState(0);
  const [nameOfSite, setNameOfSite] = useState(0);
  const [loadingProfileStr, setLoadingProfileStr] = useState("");
  const [openDialog, setOpenDialog] = useState(false)
  const [statusDialog, setStatusDialog] = useState(false)
  const [expectedLevelGH, setExpectedLevelGH] = useState(null)
  const [expectedLevelAndResGH, setExpectedLevelAndResGH] = useState(null)
  const [expectedLevelSO, setExpectedLevelSO] = useState(null)
  const [expectedLevelAndResSO, setExpectedLevelAndResSO] = useState(null)
  const [github_search, setGithubSearch] = useState(null)
  const [retrieved_github_user_email, setRetrieved_github_user_email] = useState(null)
  const [gHAdditionalRankingData, setGHAdditionalRankingData] = useState(null)
  
  const [stackoverflowSearch, setStackOverFlowSearch] = useState(false)
  const [previousUsername, setPreviousUsername] = useState("")
  const [quickAnalysisDone, setQuickAnalysisDone] = useState(false)

  useEffect(() =>  {
    if(result !== "" && hideGH && uuidCredit) setHideGH(false)
    if(resultStackOverflow !== "" && hideSO && uuidCredit) setHideSO(false)
  }, [result, hideGH, resultStackOverflow, hideSO, uuidCredit])

  useEffect(() => {
    if(github_search === false && result !== "" && resultStackOverflow !== "" && expectedLevelAndResSO !== null && !openDialog && !isLoading){
      document.getElementById('so_section').scrollIntoView()
    }
  }, [github_search, result, resultStackOverflow, expectedLevelAndResSO, openDialog, isLoading])

  useEffect(() => {
    if(expectedLevelGH !== null){
      if(checkRating(expectedLevelGH, result) )
        setExpectedLevelAndResGH(true)
      else setExpectedLevelAndResGH(false)
    }
  }, [expectedLevelGH, expectedLevelAndResGH, result])
  
  useEffect(() => {
    if(expectedLevelSO !== null){
      if(checkRating(expectedLevelSO, resultStackOverflow))
        setExpectedLevelAndResSO(true)
      else setExpectedLevelAndResSO(false)
    }
  }, [expectedLevelSO, expectedLevelAndResSO, resultStackOverflow])


  // Change the state(opendialog, ExpectedLevelAndResSO and ExpectedLevelAndResGH) and open the dialog
  const changeStateAndOpenDialog = (github) => {
    if(localStorage.getItem('uuidCredit') !== "" && localStorage.getItem('uuidCredit') !== null){
      if(github === true){
        setExpectedLevelAndResGH(null);
        setOpenDialog(true);
      }else{
        setExpectedLevelAndResSO(null);
        setOpenDialog(true);
      }
    }
  }
  //Payment modal
  const [modalShow, setModalShow] = useState(false);

  const loadingTextStr =
    "Crunching ".concat(numMilUsers.toString()) +
    " million " +
    nameOfSite.toString() +
    " Techie profiles....";
  const NOT_TOP_50 = "not_top_50";

  const navigateToRegister = () => history.push("/register");
  const setToken = ({ type, token }) => {
    if (type === GITHUB_STRING) {
      setGitHubToken(token);
    } else if (type === SO_STRING) {
      setStackOverflowToken(token);
    }
  };

  // parse the token passed from github (if any) and update username from the api
  // e.g. http://localhost:3000/?access_token=asdfasdf
  // this is a onetime check on component creation
  useEffect(() => {
    const ACCESS_STRING = "access";
    const query = new URLSearchParams(props.location.search);
    let params = {};
    for (let param of query.entries()) {
      params[param[0]] = param[1];
    }

    if (params.hasOwnProperty(ACCESS_STRING)) {
      // Store the uuidcredit in the local storage
      localStorage.setItem('uuidCredit', params[ACCESS_STRING])
      window.location.href = process.env.REACT_APP_URL_RELATIVE_RATINGS_APP
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // To log out the user
  const logout = () => {
    localStorage.removeItem('uuidCredit')
    window.location.href = process.env.REACT_APP_URL_RELATIVE_RATINGS_APP
  }

  useEffect(() => {
    // Check the local storage
    if(localStorage.getItem('uuidCredit')){
      setUuidCredit(localStorage.getItem('uuidCredit'))
      initOutstandingCredits(localStorage.getItem('uuidCredit'));
      setHideGH(true);
      setHideSO(true);
    }
  }, [])

  useEffect(() => {
    if (props.location.hash) {
      const profileURL = props.location.hash.slice(1);
      const profileProps = profileURL.split("/");

      if (profileProps.length < 2) {
        setShowError({
          show: true,
          msg: "Invalid Profile Link",
        });
      } else {
        if (profileProps.length === 3) {
          const [github, so] = profileProps;
          if (!_.isInteger(Number(github)) && _.isInteger(Number(so))) {
            setGithubSearch('both')
            getProfile.apply(this, profileProps);
            setLoadingProfileStr(`
              Crunching ${TOTAL_GITHUB_USERS} million  
              ${DISPLAY_STRING_GH} and ${TOTAL_STACKOVERFLOW_USERS} million  
              ${DISPLAY_STRING_SO}
              Techie profiles....`
            );
          } else {
            setShowError({
              show: true,
              msg: "Invalid Profile Link",
            });
          }
        } else {
          const [profile, hash] = profileProps;
          if (_.isInteger(Number(profile))) {
            getProfile("", profile, hash);
            setGithubSearch(false)
            setLoadingProfileStr(`
              Crunching ${TOTAL_STACKOVERFLOW_USERS} million  
              ${DISPLAY_STRING_SO}
              Techie profiles....`
            );
          } else if (!_.isInteger(Number(profile))) {
            setGithubSearch(true)
            getProfile(profile, "", hash);
            setLoadingProfileStr(`
              Crunching ${TOTAL_GITHUB_USERS} million  
              ${DISPLAY_STRING_GH}
              Techie profiles....`
            );
          } else {
            setShowError({
              show: true,
              msg: "Invalid Profile Link",
            });
          }
        }
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // auto check for login with github
  useEffect(() => {
    if (githubToken) {
      crunchRating();
    }
  }, [githubToken]); // eslint-disable-line react-hooks/exhaustive-deps

  // auto check for login with stackoverflow
  useEffect(() => {
    if (stackoverflowToken) {
      crunchRatingStackoverflow();
    }
  }, [stackoverflowToken]); // eslint-disable-line react-hooks/exhaustive-deps

  // Check if the user is visiting his own profile
  useEffect(() => {
    if((ownRatingGH !== true && result !== "" && hash !== "") || (ownRatingSO !== true && resultStackOverflow !== "" && hash !== "")){
      if(localStorage.getItem('techierank_github_profile_username') === username || localStorage.getItem('techierank_stackoverflow_profile_username') === SOusername){
        setShowShare(true)
      }
    }
  }, [username, SOusername, ownRatingGH, ownRatingSO, result, resultStackOverflow, hash])

  useEffect(() => {
    if(ownRatingSO === true && stackoverflowSearch === true){
      document.getElementById('so_section').scrollIntoView()
    }
  }, [ownRatingSO, stackoverflowSearch])

  // a user input check
  // if enteredVal is a valid github url then it will automatically extract the username
  // otherwise it treats whatever the user is entering as username
  const quickAnalysis = () => {
    const enteredVal = enteredText.trim();

    if (!enteredVal) {
      setShowError({
        show: true,
        msg: "the URL or username that you entered does not seem to be valid",
      });

      return;
    }

    const setPreviousSearchTrue = username=>{
      setPreviousUsername(username)
      setQuickAnalysisDone(true)
    }

    setShowError({ show: false, msg: "" });
    // check if user entered a url
    const isValidUrl = checkValidUrl(enteredVal);
    if (isValidUrl) {
      // 2021-04-012 relative-ratings-app RequestRating.js and relative-rankings-chrome-extension functions.js share this same code => move to shared component
      // check if the entered url is actually github or SO
      const isValidGithub = checkValidGitHubUrl(enteredVal);
      const isValidSO = checkValidStackOverflowUrl(enteredVal);
      
      if (isValidGithub) {
        setGithubSearch(true)
        const newUsername = extractUsername(enteredVal);
        console.log(enteredVal)
        crunchRating(newUsername, true);
        setPreviousSearchTrue(newUsername)
      } else if (isValidSO) {
        setGithubSearch(false)
        const newUserId = extractUserId(enteredVal);
        crunchRatingStackoverflow(newUserId, true);
      } else {
        setShowError({
          show: true,
          msg: "the URL that you entered does not seem to be valid",
        });
      }
    } else {
      if (Number.isInteger(Number(enteredVal))) {
        setGithubSearch(false)
        setUserId(enteredVal);
        crunchRatingStackoverflow(enteredVal);
      } else {
        setGithubSearch(true)
        crunchRating(enteredVal);
        setPreviousSearchTrue(enteredVal)
      }
    }

    
    
  };

  const detailedAnalysis = () => {
    const enteredVal = enteredText.trim();

    if (!enteredVal) {
      setShowError({
        show: true,
        msg: "the URL or username that you entered does not seem to be valid",
      });
      return;
    }

    setShowError({ show: false, msg: "" });
    
    // check if user entered a url
    const isValidUrl = checkValidUrl(enteredVal);
    if (isValidUrl) {
      // 2021-04-012 relative-ratings-app RequestRating.js and relative-rankings-chrome-extension functions.js share this same code => move to shared component
      // check if the entered url is actually github or SO
      const isValidGithub = checkValidGitHubUrl(enteredVal);

      if (isValidGithub) {
        setGithubSearch(true)
        const newUsername = extractUsername(enteredVal);
        crunchDetailedAnalysis(newUsername);
      } else {
        setShowError({
          show: true,
          msg: "the URL that you entered does not seem to be valid",
        });
      }
    } else {
      if (!Number.isInteger(Number(enteredVal))) {
        crunchDetailedAnalysis(enteredVal)
      }
    }

    /* Future modification to show all completed analysis 
    console.log(uuidCredit)
    history.push({ 
      pathname: "/dashboard", 
      state: localStorage.getItem('uuidCredit')})
      */

  }

  const twitterShare = () => {
    const profileUrl = `${process.env.REACT_APP_URL_RELATIVE_RATINGS_APP}${hash}`;
    let rankText = "";
    if (result && result !== NOT_TOP_50) {
      rankText += `top ${result}% of ${DISPLAY_STRING_GH} developers `;
    }
    if (resultStackOverflow && resultStackOverflow !== NOT_TOP_50) {
      rankText += (rankText!==""
                    ? "and "
                    : "") + `top ${resultStackOverflow}% of ${DISPLAY_STRING_SO} developers `;
    }
    const text = encodeURIComponent(
      `${
        rankText === ""
          ? `Check out my developer profile(s) on ${APP_NAME}.com!`
          : `I'm ranked in the ${rankText}on ${APP_NAME}.com - Check your rank free now!`
      } \n${profileUrl} \n\n@${APP_NAME} powered by @reputationaire`
    );

    const url = `https://twitter.com/intent/tweet?text=${text}`;
    window.open(url, "_blank");
  };

  const linkedInShare = () => {
    const profileUrl = fixedEncodeURIComponent(
      `${process.env.REACT_APP_URL_RELATIVE_RATINGS_APP}${hash}`
    );
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${profileUrl}`;
    window.open(url, "_blank");
  };

  const crunchDetailedAnalysis =async (user="", search=false) => {
    setShowError({ show: false, msg: "" });
    setShowShare(false);
    
    setIsLoading(true);

    if (user === "" && githubToken === "") {
      setShowError({
        show: true,
        msg: `Please enter a valid username/${DISPLAY_STRING_GH} URL`,
      });
      return;
    }

    if(githubToken && !search) {

    }
    else {
      crunchOtherDetailedAnalysis(user, uuidCredit, quickAnalysisDone&&user===previousUsername)
        .then((res) => {
            const uuid_github = res.data.message.uuid_github;
            if(res.data.message.credit_exhausted===true){
              setResult("")
              setModalShow(true);
              setIsLoading(false);
            }
            if(res.data.message==="success"){
              setModalShow(true)
            } 

          let average = (res.data.message.average === 100
            ? res.data.message.average
            : res.data.message.average * 100
          ).toFixed(2);

          if (average === 0.0) {
            average = 0.01;
          }

          const outstandingCredit = res.data.message.credit_remaining;
          
          setIsLoading(false);
          setOwnRatingGH(false);
          setUsername(_.unescape(user));
          setResult(average);
          setOutstandingCredit(outstandingCredit);
          setIsLoading(false);
          if (hideGH) {
            setHideGH(false);
          }
          // setExpectedLevelAndResGH(null);
          // setOpenDialog(true);
          setStatusDialog(true)
          setGHAdditionalRankingData(res.data.message.ratingData)
          setQuickAnalysisDone(false)
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            if (err.response.status === 404) {
              setShowError({ show: true, msg: "No such username" });
              return;
            }
          }
          setShowError({
            show: true,
            msg: `We're having trouble completing your request at this time`,
          });
        });
    }
  }

  const crunchRating = async (user = "", search = false) => {
    // check if username is actually set
    // user = user !== '' ? user : username;
    setShowError({ show: false, msg: "" });
    setShowShare(false);

    if (user === "" && githubToken === "") {
      setShowError({
        show: true,
        msg: `Please enter a valid username/${DISPLAY_STRING_GH} URL`,
      });
      return;
    }

    setNumMilUsers(TOTAL_GITHUB_USERS);
    setNameOfSite(DISPLAY_STRING_GH);
    setIsLoading(true);
    var user_name = ""
    if (githubToken && !search) {
      // GET AND SET GITHUB USERNAME
      await getGitHubUsername(githubToken).then((res) => {
        setUsername(_.unescape(res.data.message.username));
        user_name = _.unescape(res.data.message.username)
      });

      crunchOwnRating(githubToken)
        .then((res) => {
          let average = res.data.message.average;
          let newResult = (average === 100 ? average : average * 100).toFixed(
            2
          );

          if (newResult > 50) {
            newResult = NOT_TOP_50;
          } else if (newResult === 0.0) {
            newResult = 0.01;
          }

          setOwnRatingGH(true);
          setResult(newResult);
          setIsLoading(false);

          if (!uuidCredit) {
            generate_profile(githubToken, stackoverflowToken).then((res) => {
              const hash = res.data.message.profile;
              setHash(hash);
              setShowShare(true);
              window.history.pushState(
                {},
                `Your ${APP_NAME} Profile`,
                `${process.env.REACT_APP_URL_RELATIVE_RATINGS_APP}${hash}`
              );
            });
          }
          if(user_name !== ""){
            localStorage.setItem('techierank_github_profile_username', user_name)
          }
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            if (err.response.status === 404) {
              setShowError({ show: true, msg: "No such username" });
              return;
            }
          }
          setShowError({
            show: true,
            msg: `We're having trouble completing your request at this time`,
          });
        });
    } else {
      crunchOtherRating(user, uuidCredit)
        .then((resp) => {
          const uuid_github = resp.data.message.uuid_github;
          axios
            .get(
              process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
                `/api/result?id=${uuid_github}&access=${uuidCredit}`
            )
            .then((res) => {
              if (res.data.message.credit_exhausted === true) {
                setResult("");
                setIsLoading(false);
                setModalShow(true);
                return;
              }

              let average = (res.data.message.average === 100
                ? res.data.message.average
                : res.data.message.average * 100
              ).toFixed(2);

              if (average === 0.0) {
                average = 0.01;
              }

              const outstandingCredit = res.data.message.credit_remaining;

              setRetrieved_github_user_email(res.data.message.got_email)
              setOwnRatingGH(false);
              setUsername(_.unescape(user));
              setResult(average);
              setOutstandingCredit(outstandingCredit);
              setIsLoading(false);
              if (hideGH) {
                setHideGH(false);
              }
              // setExpectedLevelAndResGH(null);
              // setOpenDialog(true);
              changeStateAndOpenDialog(true)
              setGHAdditionalRankingData(res.data.message.ratingData);
            })
            .catch((err) => {
              setIsLoading(false);
              setShowError({
                show: true,
                msg: "Please check the url/id and submit again.",
              });
            });
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            if (err.response.status === 404) {
              setShowError({ show: true, msg: "No such username" });
              return;
            }
          }
          setShowError({
            show: true,
            msg: `We're having trouble completing your request at this time`,
          });
        });
    }
  };

  const getProfile = (github = "", userid = "", hash) => {
    setIsLoading(true);
    const requestUrl =
      process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/check-profile";

    const data = {
      github,
      stackoverflow: userid,
      hash,
      uuidCredit: localStorage.getItem('uuidCredit'),
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(requestUrl, data, config)
      .then((res) => {
        if (res.data.message.so_average !== "") {
          let so_average = res.data.message.so_average.toFixed(2);
          if (so_average === 0.0) {
            so_average = 0.01;
          }

          setSOusername(_.unescape(res.data.message.so_username));
          setUserId(userid);
          setResultStackOverflow(so_average);
          setOwnRatingSO(false);
          // setExpectedLevelAndResSO(null);
          // setOpenDialog(true);
          changeStateAndOpenDialog(false)
        }

        if (res.data.message.github_average !== "") {
          let github_average = (res.data.message.github_average === 100
            ? res.data.message.github_average
            : res.data.message.github_average * 100
          ).toFixed(2);
          if (github_average === 0.0) {
            github_average = 0.01;
          }

          setRetrieved_github_user_email(res.data.message.got_email)
          setUsername(_.unescape(github));
          setOwnRatingGH(false);
          setResult(github_average);
          // setExpectedLevelAndResGH(null);
          // setOpenDialog(true);
          const hash = "#"+window.location.href.split('#')[1]
          setHash(hash)
          changeStateAndOpenDialog(true)
        }
        setIsLoading(false);
      })
      .catch((err) => {

console.error(err);

        setIsLoading(false);
        setShowError({ show: true, msg: err.response.data.message.status });
      });
  };

  const crunchRatingStackoverflow = async (user = "", search = false) => {
    // check if userid is actually set
    // user = user !== '' ? user : userid;
    setShowError({ show: false, msg: "" });
    setShowShare(false);
    if (user === "" && stackoverflowToken === "") {
      setShowError({
        show: true,
        msg: `Please enter a valid userID/${DISPLAY_STRING_SO} URL`,
      });
      return;
    }

    setNumMilUsers(TOTAL_STACKOVERFLOW_USERS);
    setNameOfSite(DISPLAY_STRING_SO);
    setIsLoading(true);
    var user_name = ""

    if (stackoverflowToken && !search) {
      await getStackOverflowUsername(stackoverflowToken).then((res) => {
        setSOusername(_.unescape(res.data.message.username));
        setUserId(res.data.message.user_id);
        user_name = _.unescape(res.data.message.username)
      });

      crunchOwnRatingStackOverflow(stackoverflowToken)
        .then((res) => {
          let average = res.data.message.average;
          let newResult = average.toFixed(2);

          if (newResult > 50) {
            newResult = NOT_TOP_50;
          } else if (newResult === 0.0) {
            newResult = 0.01;
          }

          setOwnRatingSO(true);
          setResultStackOverflow(newResult);
          setIsLoading(false);

          if (!uuidCredit) {
            generate_profile(githubToken, stackoverflowToken).then((res) => {
              const hash = res.data.message.profile;
              setHash(hash);
              setShowShare(true);
              window.history.pushState(
                {},
                `Your ${APP_NAME} Profile`,
                `${process.env.REACT_APP_URL_RELATIVE_RATINGS_APP}${hash}`
              );
            });
          }
          if(user_name !== ""){
            localStorage.setItem('techierank_stackoverflow_profile_username', user_name)
          }
          if(stackoverflowSearch === false){
            setStackOverFlowSearch(true)
          }
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            if (err.response.status === 404) {
              setShowError({ show: true, msg: "Please check the url/id and submit again." });
              return;
            }
          }
          setShowError({
            show: true,
            msg: `We're having trouble completing your request at this time`,
          });
        });
    } else {
      getStackOverflowUsername_userid(user).then((res) => {
        setSOusername(_.unescape(res.data.message.username));
      });

      crunchOtherRatingStackOverflow(user)
        .then((resp) => {
          const uuid_stackoverflow = resp.data.message.uuid_stackoverflow;
          axios
            .get(
              process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
                `/api/stackoverflow/result?id=${uuid_stackoverflow}&access=${uuidCredit}`
            )
            .then((res) => {
              if (res.data.message.credit_exhausted === true) {
                setResultStackOverflow("");
                setIsLoading(false);
                setModalShow(true);
                return;
              }
              let average = res.data.message.average.toFixed(2);
              const outstandingCredit = res.data.message.credit_remaining;

              if (average === 0.0) {
                average = 0.01;
              }

              setOwnRatingSO(false);
              setUserId(user);
              setResultStackOverflow(average);
              setOutstandingCredit(outstandingCredit);
              setIsLoading(false);
              if (hideSO) {
                setHideSO(false);
              }
              // setExpectedLevelAndResSO(null);
              // setOpenDialog(true);
              changeStateAndOpenDialog(false)
            })
            .catch((err) => {
              setIsLoading(false);
              setShowError({
                show: true,
                msg: "Please check the url/id and submit again.",
              });
            });
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            if (err.response.status === 404) {
              setIsLoading(false);
              setShowError({ show: true, msg: "No such username" });
              return;
            }
          }
          setIsLoading(false);
          setShowError({
            show: true,
            msg: `We're having trouble completing your request at this time`,
          });
        });
    }
  };

  const initOutstandingCredits = (uuidCredit) => {
    let requestUrl =
      process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/get-user-info";

    let data = {
      access: uuidCredit,
    };

    let config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios.post(requestUrl, data, config).then((res) => {
      setOutstandingCredit(res.data.message.outstanding_credit);
    });
  };

  return (
    <>
      {drawerVisible ? (
        <Drawer
          isCredit={uuidCredit}
          credit={outstandingCredit}
          showPayment={() => setModalShow(true)}
          goToRegister={() => navigateToRegister()}
          closeDrawer={() => toggleDrawer(false)}
          logout={() => logout()}
        />
      ) : null}
      <div className="wrapper">
        <Nav
          isCredit={uuidCredit}
          credit={outstandingCredit}
          showPayment={() => setModalShow(true)}
          goToRegister={() => navigateToRegister()}
          openDrawer={() => toggleDrawer(true)}
          logout={() => logout()}
        />

        {modalShow ? (
          <PaymentsModal hidePayment={() => setModalShow(false)} />
        ) : null}
        
        {isLoading ? (
          <LoadingAnimation
            loadingText={
              nameOfSite === 0 ? loadingProfileStr : loadingTextStr
            }
          />
        ) : (
          <div id="container" className="container">
            <main id="home" className="show">
              {uuidCredit ? (
                <section className="userFormContainer">
                  <form>
                    <div className="inputContainer">
                      <input
                        id="search"
                        type="text"
                        placeholder={`${DISPLAY_STRING_GH} user name/URL or ${DISPLAY_STRING_SO} user number/URL`}
                        value={enteredText}
                        onChange={(e) => setEnteredText(e.target.value)}
                      />
                      <button id="submit-quick" type="submit" title="Quick rank analysis for Github and Stackoverflow users"
                          onClick={(e) => {
                            e.preventDefault();
                            quickAnalysis();
                          }}>
                        <img src={searchIcon} alt="search" /> Quick <br />
                        1 credit
                      </button>
                      <button id="submit-detailed" type="submit" title="Detailed analysis for Github users" disabled={(enteredText.includes("http") && !checkValidGitHubUrl(enteredText)) || Number.isInteger(Number(enteredText))} onClick={
                        (e) => {
                          e.preventDefault();
                          detailedAnalysis();
                        }
                      }> Detailed <br /> {quickAnalysisDone&&(enteredText===previousUsername || extractUsername(enteredText)=== previousUsername) ?2:3} credits
                    </button>
                    </div>
                  </form>
                </section>
              ) : null}

              {false ? (
                <section className="profile">
                  <div className="nameLocation">
                    <img src={profileImg} alt="profile" />
                    <div>
                      <h3>{username}</h3>
                      <p></p>
                    </div>
                  </div>

                  {/* {false ? (
                    <div className="followers">
                      <p>GITHUB FOLLOWERS</p>
                      <h4>5</h4>
                      <p>STACK OVERFLOW REPUTATION</p>
                      <h4>123</h4>
                    </div>
                  ) : null} */}
                </section>
              ) : null}

              {/* Shown to non logged in users */}
              {!uuidCredit && !githubToken && !stackoverflowToken && !result && !resultStackOverflow ? (
                  <NonLoggedView navigateToRegister={navigateToRegister}/>
              ) : null}

              {!hideGH ? (
                <section className="gitHub-ranking">

                  <div className="gitHub-ranking-heading">
                    <div className="username-title">
                      <h3>
                        {result ? (
                          <span className="titleToolTip">
                            <a
                              href={`https://github.com/${username}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <p>
                                {`${username}'s`}
                              </p>
                              {` ${DISPLAY_STRING_GH}`}
                              {ownRatingGH || uuidCredit ? `` : ` (profile ownership verified)`}
                              <img src={newTabIcon} alt="new-tab" />                              
                            </a>
                            <p className="tooltiptext">
                              Open {DISPLAY_STRING_GH} Profile
                            </p>
                          </span>
                        ) : (
                          <span>
                            Are you a developer? <small style={{fontWeight: "normal"}}>Check your {DISPLAY_STRING_GH} rank then stand out by sharing a free verified credential proving ownership of your {DISPLAY_STRING_GH} to LinkedIn</small>
                          </span>
                        )}
                      </h3>
                    </div>
                    {result ? (
                      <a
                        href={`https://github.com/${username}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={gitHubLogo} alt="github-logo" />
                      </a>
                    ) : (
                      <>
                        <span id="btn-authorize-gitHub" style={{order: "2"}} className="btn-login">
                          <div>
                            <LoginGitHub onCode={setToken} />
                            <p style={{textAlign: "center"}}>No signup required!<a href="https://linkedin.com/in/hinesystems" target="_blank">Example</a>(scroll down to Licenses & certifications)</p>
                          </div>
                        </span>
                      </>
                    )}
                  </div>


                  <div className="gitHub-ranking-details" style={{margin: result ? '20px 0' : '0'}}>
                    {result ? (
                      <>
                        {/* {
                          expectedLevelAndResGH === true && Congrats_Msg(true)
                        } */}
                        <RankingGHOrSO rankingAndOwnRatingAndGHElseSO={[result, ownRatingGH, true, expectedLevelAndResGH]}
                        result={result}
                        resultStackOverflow={resultStackOverflow}
                        gHAdditionalRankingData={gHAdditionalRankingData}
                        username ={username}
                        expectedLevelAndResGH={expectedLevelAndResGH}
                        expectedLevelGH={expectedLevelGH}
                        expectedLevelSO={expectedLevelSO}/>

                        {/* <span className="tooltip">
                          <p className="tooltiptext tooltiptext_ranking" >
                            <br/>
                            Ranking is based on contributions to code repositories, repository stars (showing quality of projects), and a Techie's following
                          </p>
                        </span> */}
                        {
                          expectedLevelAndResGH === false && NotEnoughData_Msg(true, username,retrieved_github_user_email, expectedLevelAndResGH)
                        }
                        {uuidCredit &&  expectedLevelAndResGH === false ? (
                          <>
                            <p className="gitHub-ranking-details-pa">A TechieRank ranking should <b>not</b> be required of all Techies and it should <b>not</b> replace your existing evaluation processes.</p>
                            <br/>
                          </>) : null}
                      </>
                    ) : ( null )}
                  </div>


                  {result ? (
                    
                    <div className="soft-skills">
                      <h2>Soft skills typically demonstrated by top ranked {DISPLAY_STRING_GH} Techies</h2>
                      <div className="iconContainer">
                        <div>
                          <img src={passionIcon} alt="passion-icon" />
                          <p>Motivated with passion for technology</p>
                        </div>
                        <div>
                          <img src={attitudeIcon} alt="info-icon" />
                          <p>Growth mindset & attitude towards learning</p>
                        </div>
                        <div>
                          <img src={communityIcon} alt="info-icon" />
                          <p>Creative & contribute to other's projects</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {result && !githubToken && !uuidCredit ? (
                  // Moved the common code to seperate component
                  <GithubRankingHeading
                    setToken={ setToken}
                    uuidCredit={uuidCredit}
                  />

                  ) : null}

        {/* {ownRatingGH ? (
        <>
                  <OtherRankingRegister show_btn_Tag={true} navigateToRegister={navigateToRegister} show_a_Tag={false} />
        </>
        ) : null} */}
                </section>
              ) : null}

              {/* Shown when viewing someone's profile or not logged in */}
              {hideGH || uuidCredit || githubToken || stackoverflowToken ? null : (
              <>
                <section className="other-ranking">
                  <div className="other-ranking-heading">
                    <h3>Get a gauge on any {DISPLAY_STRING_GH} developer's rank &amp; soft skills</h3>
                  </div>

                  <div className="soft-skills">
                    <div>
                      <p>
                      {DISPLAY_STRING_GH} is where {TOTAL_GITHUB_USERS} pesudo anonymous million developers contribute to open source &amp; manage their code repositories, demonstrating:
                      </p>
                      <br/>
                    </div>

                    <div className="iconContainer">
                      <div>
                        <img src={passionIcon} alt="passion-icon" />
                        <p>Motivation & passion for technology</p>
                      </div>
                      <div>
                        <img src={attitudeIcon} alt="info-icon" />
                        <p>Growth mindset & attitude towards learning</p>
                      </div>
                      <div>
                        <img src={communityIcon} alt="info-icon" />
                        <p>Creativity & contribution to other's projects</p>
                      </div>
                    </div>
                  </div>

                  {!uuidCredit ? (
                    <>
                      <OtherRankingRegister show_btn_Tag={true} navigateToRegister={navigateToRegister} show_a_Tag={false} />
                    </>
                  ) : null}
                </section>
              </>
              )}


              {!hideSO ? (
                <section className="stackoverflow-ranking" id='so_section' >
                  <div className="stackoverflow-ranking-heading">
                    <div className="username-title">
                      <h3>
                        {resultStackOverflow ? (
                          <span className="titleToolTip">
                            <a
                              href={`https://stackoverflow.com/users/${userid}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <p>
                                {`${SOusername}'s`}
                              </p>
                              {` ${DISPLAY_STRING_SO}`}
                              {ownRatingSO || uuidCredit ? `` : ` (profile ownership verified)`}
                              <img src={newTabIcon} alt="new-tab" />                            
                            </a>
                            <p className="tooltiptext">
                              Open {DISPLAY_STRING_SO} Profile
                            </p>
                          </span>
                        ) : (
                          <span>
                            Are you a developer? <small style={{fontWeight: "normal"}}>Check your {DISPLAY_STRING_SO} rank then stand out by sharing a free verified credential proving ownership of your {DISPLAY_STRING_SO} to LinkedIn</small>
                          </span>
                        )}
                      </h3>
                    </div>
                    {resultStackOverflow ? (
                      <a
                        href={`https://stackoverflow.com/users/${userid}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={stackoverflowLogo} alt="SO-logo" />
                      </a>
                    ) : (
                      <>
                        <span id="btn-authorize-stackoverflow" style={{order: "2"}} className="btn-login">
                          <div>
                            <LoginStackOverflow onCode={setToken} />
                            <p style={{textAlign: "center"}}>No signup required!<a href="https://linkedin.com/in/hinesystems" target="_blank">Example</a>(scroll down to Licenses & certifications)</p>
                          </div>
                        </span>
                      </>
                    )}
                  </div>

                  <div className="stackoverflow-ranking-details" style={{margin: resultStackOverflow ? '20px 0' : '0'}}>
                    {resultStackOverflow ? (
                      <>
                        {/* {
                          expectedLevelAndResSO === true && Congrats_Msg(false)
                        } */}
                        <RankingGHOrSO rankingAndOwnRatingAndGHElseSO={[resultStackOverflow, ownRatingSO, false, expectedLevelAndResSO]}
                        result={result}
                        resultStackOverflow={resultStackOverflow}
                        gHAdditionalRankingData={gHAdditionalRankingData}
                        username ={username}
                        expectedLevelAndResGH={expectedLevelAndResGH}
                        expectedLevelGH={expectedLevelGH}
                        expectedLevelSO={expectedLevelSO} />
                        {/* <span className="tooltip">
                            <p className="tooltiptext tooltiptext_ranking">
                              <br/>
                              Ranking is based on reputation on {DISPLAY_STRING_SO} determined by community votes on quality questions, answers and comments
                            </p>
                          </span> */}
                        {
                          expectedLevelAndResSO === false && NotEnoughData_Msg(false, username,retrieved_github_user_email, expectedLevelAndResGH)
                        }
                        {uuidCredit &&  expectedLevelAndResSO === false ? (
                          <>
                            <p className="gitHub-ranking-details-pa">A TechieRank ranking should <b>not</b> be required of all Techies and it should <b>not</b> replace your existing evaluation processes.</p>
                            <br/>
                          </>
                        ) : null}
                      </>
                    ) : (
                        null
                    )}

                  </div>

                    {resultStackOverflow ? (

                    <div className="soft-skills">
                      <h2>Soft skills typically demonstrated by top ranked {DISPLAY_STRING_SO} Techies</h2>

                      <div className="iconContainer">
                        <div>
                          <img src={trustIcon} alt="trust-icon" />
                          <p>Ability to solve issues themselves & comfort with ambiguity</p> 
                        </div>
                        <div>
                          <img src={commIcon} alt="comm-icon" />
                          <p>Good communication skills & ability to work with others</p>
                        </div>
                        <div>
                          <img src={qaIcon} alt="tech-icon" />
                          <p>Technically proficient</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {resultStackOverflow && !stackoverflowToken && !uuidCredit ? (

                  // Moved the code to StackOverFlowRankingHeading component
                    <StackOverflowRankingHeading 
                      setToken={setToken}
                      uuidcredit={uuidCredit}
                    />) : null}

                  {/* {ownRatingSO ? (
                  <>
                              <OtherRankingRegister show_btn_Tag={true} navigateToRegister={navigateToRegister} show_a_Tag={false} />
                  </>
                  ) : null} */}

                </section>
                ) : null}

              {hideSO || uuidCredit || githubToken  || stackoverflowToken ? null : (

                <section className="other-ranking">
                  <div className="other-ranking-heading">
                    <h3>Get a gauge on any {DISPLAY_STRING_SO} developer's rank &amp; soft skills</h3>
                  </div>

                  <div className="soft-skills">
                    <div>
                      <p>
                        {DISPLAY_STRING_SO} is the largest pseudo anonymous online community for {TOTAL_STACKOVERFLOW_USERS} million developers to learn &amp; share​ ​their programming ​knowledge, demonstrating:
                      </p>
                      <br/>
                    </div>

                    <div className="iconContainer">
                        <div>
                          <img src={trustIcon} alt="trust-icon" />
                          <p>Ability to solve issues themselves & comfort with ambiguity</p>  
                        </div>
                        <div>
                          <img src={commIcon} alt="comm-icon" />
                          <p>Good communication skills & ability to work with others</p>
                        </div>
                        <div>
                          <img src={qaIcon} alt="tech-icon" />
                          <p>Technical proficiency</p>
                        </div>
                    </div>
                  </div>

                  {!uuidCredit ? (
                    <>
                      <OtherRankingRegister show_btn_Tag={true} navigateToRegister={navigateToRegister} show_a_Tag={false} />
                    </>
                  ) : null}
                </section>
              )}

              {!uuidCredit && !result && !resultStackOverflow ? null : (
                <section className="other-ranking">
                  <div className="other-ranking-heading" style={{display: (expectedLevelAndResGH !== null || expectedLevelAndResSO !== null) ? 'none': 'flex'}} >
                    {/* <h3>Do all developer applicants look the same?</h3> */}
                    <h3>{RecruiterOrEmployerSalesTitleText()}</h3>
                  </div>

                  {uuidCredit && (result || resultStackOverflow) ? null : (
                    <div className="other-ranking-details">
                      {RecruiterOrEmployerSalesText()}
                    </div>
                  )}

                  {
                    openDialog &&
                        <LEVEL_DIALOG setExpectedLevelGH={setExpectedLevelGH} setExpectedLevelSO={setExpectedLevelSO} github_search={github_search} setOpenDialog={setOpenDialog} />
                  }

                  {
                    statusDialog && (
                      <div className="what-level" >
                        <div className="what-level_content" id="statusDialog">
                          <div className="what-level-header-wraper">
                            <h3>
                            We've started detailed code analysis on all of {username}'s code.
                            <br/>This typically takes 20-60 minutes but may take longer.
                            <br/>We will email you the results as soon as they are ready.
                            </h3>
                          </div>
                          <button onClick={()=>{setStatusDialog(false); console.log(statusDialog)}}>I will keep and eye on my inbox!</button>
                        </div>
                      </div>
                    )
                  }
                    {!uuidCredit ? ( 
                        <>
                          <OtherRankingRegister show_btn_Tag={true} navigateToRegister={navigateToRegister} show_a_Tag={true} />
                        </>
                    ) : null}
                  </section>
                )}

              {uuidCredit && (result || resultStackOverflow) ? ( 
                <section className="other-ranking">
                  <div className="other-ranking-heading">
                    <h3>Ready to automate within your ATS?</h3>
                  </div>
                  <div className="other-ranking-details">
                    <>
                      <span>
                      <p className="p-other-desc">
                        Get your <a style={{textDecoration: "underline"}} href="https://chrome.google.com/webstore/detail/techierank-github-stack-o/hafpijmdkicjolibafkgekojggaaicid" target="_blank" rel="noopener noreferrer">free Chrome Extension</a> to automatically be shown the rank &amp; soft skills of
                          any {DISPLAY_STRING_GH} or {DISPLAY_STRING_SO} profile you browse to.
                          <br/><br/>It even displays the rank above developer's {DISPLAY_STRING_GH} or {DISPLAY_STRING_SO} profile links anywhere on the web
                            - for example above profile links within applicant's web based CV or your web based ATS!
                        </p>
                      </span>
                    </>
                  </div>
                  <OtherRankingRegister show_a_Tag={true} show_btn_Tag={false} />
                </section>) : null}

              {!uuidCredit ?
              <section className="other-ranking">
                <div className="other-ranking-heading">
                  <h3>Educational Resources</h3>
                </div>
                <div className="other-ranking-details">
                  <p className="p-other-desc">
                  <a href="how-to-land-that-developer-job-you-want.html" target="blank"><u>How to land that Developer Job you want</u></a>
                  </p>
                </div>
              </section> : null}

            </main>
          </div>
          )}

          <div className="scroller">
            <h3>Some partner companies hiring & accepting TechieRank profiles</h3>
          </div>
          <div style={{width: "80%", height: "250px"}}>
            <iframe title="logos-scroller" src={process.env.REACT_APP_URL_SCROLLER+'techierank'} width="100%" height= "225px"></iframe>
          </div>
        <Footer />
      </div>

      { !ownRatingGH && !ownRatingSO ? null : (
      <>
            {hash && !showShare ? (
              <button onClick={() => setShowShare(true)} className="shareButton">
                <p>Verified</p>
                <img src={LinkedInLogo} alt="share-icon" />
                <p>Credential</p>
              </button>
            ) : null}
            {showShare ? (
              <Share
                hash={hash}
                twitter={() => twitterShare()}
                linkedin={() => linkedInShare()}
                gitrank={result}
                sorank={resultStackOverflow}
                hideShare={() => setShowShare(false)}
                onCode={setToken}
              />
            ) : null}
      </>
      )}

      {showError.show ? (
        <ErrorCard
          msg={showError.msg}
          clearError={() => setShowError({ show: false, msg: "" })}
        />
      ) : null}
    </>
  );
};

export default RequestRating;
